import React from "react";
import "../Css/NewsBlogs.css";

const Blogs = () => {
  return (
    <div className="newsblogs-container">

      {/* ── Recognition & Features Section ── */}
      <h2 className="newsblogs-page-title">Recognition &amp; Features</h2>

      <div className="newsblogs-section-box">
        <h4 className="newsblogs-subheading">As Featured In</h4>
        <ul className="newsblogs-dot-list">
          <li>
            <a href="https://nwpf.org/category/blog/" target="_blank" rel="noreferrer">
              NWPF Blog Feature
            </a>
          </li>
          <li>
            <a href="https://www.apdaparkinson.org/wp-content/uploads/2026/07/NW_ParkinsonPathfinder_Summer26_NW_Final.pdf" target="_blank" rel="noreferrer">
              APDA Parkinson Pathfinder
            </a>
          </li>
        </ul>
      </div>

      {/* ── Table Tennis & Athlete News Section ── */}
      <h2 className="newsblogs-page-title" style={{ marginTop: "60px" }}>Table Tennis &amp; Athlete News</h2>

      {/* 2026 */}
      <h3 className="newsblogs-heading">2026:</h3>
      <ul>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.omnipong.com/T-tourney.asp?t=103&r=5549"
            target="_blank"
            rel="noreferrer"
            title="Ahan Vangala: Third Place U1800 Junior."
          >
            Ahan Vangala: Third Place U1800 Junior.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.omnipong.com/T-tourney.asp?t=103&r=5549"
            target="_blank"
            rel="noreferrer"
            title="Amrit: Winner U1700 Hardbat, Junior Hardbat (2nd Place)."
          >
            Amritshyaam Gautam: Winner U1700 Hardbat, Junior Hardbat (2nd Place).
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.omnipong.com/T-tourney.asp?t=103&r=5549"
            target="_blank"
            rel="noreferrer"
            title="Raghav Shah: U1700 Hardbat (3rd Place)."
          >
            Raghav Shah: U1700 Hardbat (3rd Place).
          </a>
        </li>
        <li>
          {/* TODO: swap in the specific 2026 U17 roster announcement link once USATT posts it; page currently still shows the 2025 roster. */}
          <a
            className="newsblogs-link"
            href="https://www.usatt.org/u17-boys-team"
            target="_blank"
            rel="noreferrer"
            title="Sivaraam Velayutham: Selected to U17 US National Team."
          >
            Sivaraam Velayutham: Selected to U17 US National Team.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://fvttc.org/2026/06/19/2026-usatt-midwest-championship-tournament-report/"
            target="_blank"
            rel="noreferrer"
            title="Shriraam Velayutham: USATT Midwest Regionals U17 (2nd Place)."
          >
            Shriraam Velayutham: USATT Midwest Regionals U17 (2nd Place).
          </a>
        </li>
        <li>
          <span className="newsblogs-link">
            Shriya Kodaty: U13 National Ranking #14.
          </span>
        </li>
      </ul>

      {/* 2025 */}
      <h3 className="newsblogs-heading">2025:</h3>
      <ul>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.usatt.org/news/2025/june/30/kumar-and-moyland-capture-mixed-doubles-title-at-2025-us-nationals#Rating_Event_National_Champions"
            target="_blank"
            rel="noreferrer"
            title="Under 2000 Junior: Saicharan Vellanki won the national title."
          >
            Under 2000 Junior: Saicharan Vellanki won the national title.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://omnipong.com/T-tourney.asp?t=103&r=4625"
            target="_blank"
            rel="noreferrer"
            title="Amritshyaam Gautam: Winner U1800 Junior, U1900 Junior (2nd Place), U3100 Doubles (3rd Place)."
          >
            Amritshyaam Gautam: Winner U1800 Junior, U1900 Junior (2nd Place),
            U3100 Doubles (3rd Place).
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://omnipong.com/T-tourney.asp?t=103&r=4625"
            target="_blank"
            rel="noreferrer"
            title="Raghav Shah: Second Place U4000 Doubles."
          >
            Raghav Shah: Second Place U4000 Doubles.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://natabletennis.com/tournaments/results.php"
            target="_blank"
            rel="noreferrer"
            title="Ahan Vangala: North America JOOLA Teams Division 7 Runner-Up."
          >
            Ahan Vangala: North America JOOLA Teams Division 7 Runner-Up.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.usatt.org/u15-boys-team"
            target="_blank"
            rel="noreferrer"
            title="Sivaraam Velayutham: Selected to U15 US National Team."
          >
            Sivaraam Velayutham: Selected to U15 US National Team.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://fvttc.org/2026/06/19/2026-usatt-midwest-championship-tournament-report/"
            target="_blank"
            rel="noreferrer"
            title="Shriraam Velayutham: WTT (San Francisco) U15 (3rd Place)."
          >
            Shriraam Velayutham: WTT (San Francisco) U15 (3rd Place).
          </a>
        </li>
        <li>
          <span className="newsblogs-link">
            Shriya Kodaty: US Nationals U1200 — Silver; US Nationals U11 Girls Doubles — Silver; US Open Teams Division 7 — Gold; US Open U11 Girls Doubles — Silver; US Open U11 Mixed Doubles — Silver; WTT Youth San Francisco U11 — Champion (Gold); WTT Youth San Francisco U13 — Semi-Finalist (Bronze); WTT World Ranking U11 #6; California State Championship U2000 Doubles — Champion (Gold); US Pacific Regionals — Semi-Finalist; U11 National Ranking #11.
          </span>
        </li>
        <li>
          <span className="newsblogs-link">
            Siddharth Kodaty: US Open Teams Division 7 — Gold; LATTA U1650 — Gold; ICC Joola Spring Open U1750 — Gold.
          </span>
        </li>
      </ul>

      {/* 2024 */}
      <h3 className="newsblogs-heading">2024:</h3>
      <ul>
        <li>
          <a
            className="newsblogs-link"
            href="https://omnipong.com/T-tourney.asp?t=103&r=3834"
            target="_blank"
            rel="noreferrer"
            title="Sriprahan Tellagaddala: Winner U1300 Junior, U1400 Junior (3rd Place)."
          >
            Sriprahan Tellagaddala: Winner U1300 Junior, U1400 Junior (3rd
            Place).
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://omnipong.com/T-tourney.asp?t=103&r=3834"
            target="_blank"
            rel="noreferrer"
            title="Amritshyaam Gautam: Winner Sandpaper U1700, U4000 Doubles (2nd place), U3100 Doubles (3rd Place), U2000 Hardbat Singles (3rd Place)."
          >
            Amritshyaam Gautam: Winner Sandpaper U1700, U4000 Doubles (2nd
            place), U3100 Doubles (3rd Place), U2000 Hardbat Singles (3rd
            Place).
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://omnipong.com/T-tourney.asp?t=103&r=4088"
            target="_blank"
            rel="noreferrer"
            title="Amritshyaam Gautam: (US Open) Winner U3100 Doubles, Junior Hardbat Singles (3rd Place)."
          >
            Amritshyaam Gautam: (US Open) Winner U3100 Doubles, Junior Hardbat
            Singles (3rd Place).
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.omnipong.com/T-tourney.asp?t=103&r=4088"
            target="_blank"
            rel="noreferrer"
            title="Raghav Shah: (US Open) Second Place U1800 Junior, U4000 & U3100 Doubles, Junior Hardbat Singles, U1600 Junior(3rd Place)."
          >
            Raghav Shah: (US Open) Second Place U1800 Junior, U4000 &amp; U3100
            Doubles, Junior Hardbat Singles, U1600 Junior(3rd Place).
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://omnipong.com/T-tourney.asp?t=103&r=3834"
            target="_blank"
            rel="noreferrer"
            title="Saicharan Vellanki: Third Place U1900 Junior."
          >
            Saicharan Vellanki: Third Place U1900 Junior.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://fvttc.org/2026/06/19/2026-usatt-midwest-championship-tournament-report/"
            target="_blank"
            rel="noreferrer"
            title="Sivaraam Velayutham: WTT (San Francisco) U15 (3rd Place)."
          >
            Sivaraam Velayutham: WTT (San Francisco) U15 (3rd Place).
          </a>
        </li>
        <li>
          <span className="newsblogs-link">
            Siddharth Kodaty: US Open U1300 — Bronze.
          </span>
        </li>
      </ul>

      {/* 2023 */}
      <h3 className="newsblogs-heading">2023:</h3>
      <ul>
        <li>
          <a
            className="newsblogs-link"
            href="https://omnipong.com/T-tourney.asp?t=103&r=3404"
            target="_blank"
            rel="noreferrer"
            title="Amritshyaam Gautam: (US Open) Winner U1500 Junior, U1500 Hardbat, Hardbat Junior Boys (2nd Place)."
          >
            Amritshyaam Gautam: (US Open) Winner U1500 Junior, U1500 Hardbat,
            Hardbat Junior Boys (2nd Place).
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://omnipong.com/T-tourney.asp?t=103&r=3066"
            target="_blank"
            rel="noreferrer"
            title="Saicharan Vellanki: Second Place U1800 Junior."
          >
            Saicharan Vellanki: Second Place U1800 Junior.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://omnipong.com/T-tourney.asp?t=103&r=3066"
            target="_blank"
            rel="noreferrer"
            title="Sumedh Seetharaman: Third Place U1900 Junior."
          >
            Sumedh Seetharaman: Third Place U1900 Junior.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://omnipong.com/T-tourney.asp?t=103&r=3066"
            target="_blank"
            rel="noreferrer"
            title="Shriraam Velayutham: U13 US National Team; Third Place U13 Doubles."
          >
            Shriraam Velayutham: U13 US National Team; Third Place U13 Doubles.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://omnipong.com/T-tourney.asp?t=103&r=3066"
            target="_blank"
            rel="noreferrer"
            title="Sivaraam Velayutham: Third Place U13 Doubles."
          >
            Sivaraam Velayutham: Third Place U13 Doubles.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.omnipong.com/T-tourney.asp?t=103&r=3404"
            target="_blank"
            rel="noreferrer"
            title="Shriraam Velayutham: (US Open) Third Place U13 Doubles, U13 Mixed Doubles."
          >
            Shriraam Velayutham: (US Open) Third Place U13 Doubles, U13 Mixed
            Doubles.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.omnipong.com/T-tourney.asp?t=103&r=3404"
            target="_blank"
            rel="noreferrer"
            title="Sivaraam Velayutham: (US Open) Third Place U13 Doubles."
          >
            Sivaraam Velayutham: (US Open) Third Place U13 Doubles.
          </a>
        </li>
      </ul>

      {/* 2022 */}
      <h3 className="newsblogs-heading">2022:</h3>
      <ul>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.omnipong.com/T-tourney.asp?t=103&r=2357"
            target="_blank"
            rel="noreferrer"
            title="Shriraam Velayutham: Third Place U1600 Junior, Second Place U1700 Junior."
          >
            Shriraam Velayutham: Third Place U1600 Junior, Second Place U1700
            Junior.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.omnipong.com/T-tourney.asp?t=103&r=2357"
            target="_blank"
            rel="noreferrer"
            title="Sivaraam Velayutham: Third Place U1600 Junior."
          >
            Sivaraam Velayutham: Third Place U1600 Junior.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.omnipong.com/T-tourney.asp?t=103&r=2687"
            target="_blank"
            rel="noreferrer"
            title="Sivaraam Velayutham: (US Open) Winner U1800 Junior, Third Place U2000 Junior."
          >
            Sivaraam Velayutham: (US Open) Winner U1800 Junior, Third Place
            U2000 Junior.
          </a>
        </li>
      </ul>

      {/* 2021 */}
      <h3 className="newsblogs-heading">2021:</h3>
      <ul>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.omnipong.com/T-tourney.asp?t=103&r=2058"
            target="_blank"
            rel="noreferrer"
            title="Shriraam Velayutham: (US Open) Winner U1400 Junior."
          >
            Shriraam Velayutham: (US Open) Winner U1400 Junior.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.omnipong.com/T-tourney.asp?t=103&r=2058"
            target="_blank"
            rel="noreferrer"
            title="Sivaraam Velayutham: (US Open) Third Place U1600 Junior."
          >
            Sivaraam Velayutham: (US Open) Third Place U1600 Junior.
          </a>
        </li>
      </ul>

      {/* ── Blogs Section ── */}
      {/*
      <h2 className="newsblogs-page-title" style={{ marginTop: '60px' }}>Blogs</h2>

      <h3 className="newsblogs-heading">2025:</h3>
      <ul>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.vtsworld.org/post/vt-seva-seattle-a-table-tennis-camp-for-vt-seva-s-pillars"
            target="_blank"
            rel="noreferrer"
            title="VT Seva Seattle: A Table Tennis Camp for VT Seva's Pillars"
          >
            VT Seva Seattle: A Table Tennis Camp for VT Seva's Pillars.
          </a>
        </li>
        <li>
          <a
            className="newsblogs-link"
            href="https://www.vtsworld.org/post/from-service-to-success-vt-seva-youth-volunteer-wins-2025-u-2000-table-tennis-national-championship"
            target="_blank"
            rel="noreferrer"
            title="From Service to Success: VT Seva Youth Volunteer Wins 2025 U-2000 Table Tennis National Championship"
          >
            From Service to Success: VT Seva Youth Volunteer Wins 2025 U-2000 Table Tennis National Championship.
          </a>
        </li>
      </ul>
      */}

    </div>
  );
};

export default Blogs;